import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/logo-genesis-with-text.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_info_circle.svg'


const _hoisted_1 = { class: "\n      bg-gray-lp-100\n      h-full\n      min-h-screen\n      w-screen\n      items-center\n      justify-center\n      flex flex-col\n      font-montserrat\n    " }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col w-full max-w-400px mx-auto text-14px"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-12",
  alt: "logo genesis"
}, null, -1)
const _hoisted_4 = { class: "font-semibold text-black-lp-100 text-4xl py-6 leading-none flex justify-center" }
const _hoisted_5 = { class: "\n          flex flex-row\n          py-6\n          px-4\n          bg-gray-lp-200\n          rounded-md\n          text-gray-lp-300\n          mt-2\n          items-start\n        " }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "mr-3",
  alt: "info-circle"
}, null, -1)
const _hoisted_7 = { class: "inline-block relative w-full mt-4 mb-2.5" }
const _hoisted_8 = { class: "text-center text-14px mt-8" }
const _hoisted_9 = /*#__PURE__*/_createVNode("a", {
  href: "https://wa.me/6285180763985",
  class: "text-red-lp-100 underline",
  target: "_blank",
  rel: "noopener noreferrer"
}, "0851-8076-3985", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("a", {
  href: "mailto:system@thelionparcel.com",
  class: "text-red-lp-100 underline"
}, "system@thelionparcel.com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OTP = _resolveComponent("OTP")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_ReCaptcha = _resolveComponent("ReCaptcha")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalOtherMethod = _resolveComponent("ModalOtherMethod")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.isVerificationOTPPage)
        ? (_openBlock(), _createBlock(_component_OTP, { key: 0 }))
        : (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("verificationAccount.title")), 1),
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("span", null, _toDisplayString(_ctx.$t("verificationAccount.description", { method: _ctx.typeForm.caption })), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              (_ctx.typeForm?.value?.includes('phone'))
                ? (_openBlock(), _createBlock(_component_SelectPhoneCountry, {
                    key: 0,
                    phone: _ctx.typeForm.form,
                    code: _ctx.typeForm.phoneCode,
                    placeholder: _ctx.typeForm.placeholder,
                    error: _ctx.errorPhoneNumber,
                    onSetPhone: _ctx.setPhoneNumber,
                    onSetPhoneCode: _ctx.setPhoneCodeNumber
                  }, null, 8, ["phone", "code", "placeholder", "error", "onSetPhone", "onSetPhoneCode"]))
                : (_openBlock(), _createBlock(_component_LpInput, {
                    key: 1,
                    "data-testid": "auth-verification-input-answer",
                    type: _ctx.typeForm.type,
                    debounce: 500,
                    onChange: _ctx.handleError,
                    name: _ctx.typeForm.type,
                    placeholder: _ctx.typeForm.placeholder,
                    error: _ctx.isError,
                    errorCaption: _ctx.captionError,
                    modelValue: _ctx.typeForm.form,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.typeForm.form = $event))
                  }, null, 8, ["type", "onChange", "name", "placeholder", "error", "errorCaption", "modelValue"]))
            ]),
            _createVNode(_component_ReCaptcha, {
              class: "mb-8 flex justify-center",
              onOnSuccess: _ctx.onSuccessReCaptcha,
              onOnExpire: _ctx.onResetReCaptcha,
              onOnError: _ctx.onResetReCaptcha,
              onGrecaptcha: _ctx.onGetGrecaptcha
            }, null, 8, ["onOnSuccess", "onOnExpire", "onOnError", "onGrecaptcha"]),
            _createVNode(_component_button_fill, {
              "data-testid": "auth-verification-button-send",
              title: _ctx.$t('verificationAccount.send'),
              custom: "bg-red-lp-100 h-10",
              isDisabled: 
          !_ctx.typeForm.form ||
            (_ctx.typeForm.value.includes('email') &&
              _ctx.errorFormEmail(_ctx.typeForm.form)) ||
            (_ctx.typeForm.value.includes('phone') &&
              _ctx.validatePhoneNumber(_ctx.typeForm.form)) || !_ctx.captchaToken
        ,
              onClick: _ctx.submitVerification,
              isLoading: _ctx.isLoading
            }, null, 8, ["title", "isDisabled", "onClick", "isLoading"]),
            (!_ctx.isInternal)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  "data-testid": "auth-verification-link-other-method",
                  class: "text-14px mt-8 text-red-lp-1700 font-semibold",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModalOtherMethod && _ctx.closeModalOtherMethod(...args)))
                }, _toDisplayString(_ctx.$t("verificationAccount.useOtherMethod")), 1))
              : (_ctx.isInternal)
                ? (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "text-14px mt-8 text-red-lp-1700 font-semibold",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickMethodInternal && _ctx.onClickMethodInternal(...args)))
                  }, _toDisplayString(_ctx.$t("verificationAccount.useMethodWith")) + " " + _toDisplayString(_ctx.typeForm.value.includes("phone") ? _ctx.$t("verificationAccount.email") : _ctx.$t("verificationAccount.phoneNumber")), 1))
                : _createCommentVNode("", true),
            _createVNode("p", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t("verificationAccount.helpWhatsApp")) + " ", 1),
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("verificationAccount.orEmailTo")) + " ", 1),
              _hoisted_10
            ])
          ])),
      _createVNode(_component_Footer)
    ]),
    (_ctx.isErrorInternetOrSystem)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          onCancel: _ctx.handleErrorClose,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.submitVerification,
          modal: ""
        }, null, 8, ["onCancel", "errorType", "onTryAgain"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_ModalOtherMethod, {
      title: _ctx.$t('verificationAccount.chooseMethodTitle'),
      onClose: _ctx.closeModalOtherMethod
    }, {
      content: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.methodsPartnerClient, (key, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "font-medium text-12px xxl:text-14px"
          }, [
            _createVNode(_component_LpButton, {
              id: "method-verification",
              "data-testid": 'auth-verification-button-method-' + key.value,
              onClick: ($event: any) => (_ctx.onClickMethodVerification(key)),
              outline: "",
              title: key.title,
              disabled: _ctx.showError.form,
              type: "submit",
              color: "gray-lp-1300",
              colorHover: "red-lp-100",
              textColorHover: "red-lp-100",
              customClass: "\n            w-full\n            my-4\n            font-semibold\n          "
            }, null, 8, ["data-testid", "onClick", "title", "disabled"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["title", "onClose"]), [
      [_vShow, _ctx.showModalOtherMethod]
    ])
  ], 64))
}